module.exports = __webpack_public_path__ + "img/ico_detail_l.d6cbff52.svg";